<template>
  <button
    :style="buttonStyle"
    class="flex items-center justify-center rounded-2xl bg-pink-500 font-bold uppercase tracking-wide text-white shadow-md transition hover:bg-pink-600 active:scale-95"
    @click="onClick"
  >
    {{ text }}
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Props = {
  text: string;
  width?: string;
  height?: string;
  onClick?: () => void;
};

const props = withDefaults(defineProps<Props>(), {
  width: "100%",
  height: "56px",
  onClick: () => {},
});

const buttonStyle = computed(() => ({
  width: props.width,
  height: props.height,
}));
</script>
